import { createSlice } from '@reduxjs/toolkit';

const initialState={
    reporting:null
}
export const reportingSlice = createSlice({
  name: 'reporting',
  initialState,
  reducers: {

    setReporting: (state, action) => {
      state.reporting = action.payload;
      
      
    },
    setLogoutReporting: (state,action)=>{
      state.reporting=null
    }
  },
});
export const {  setReporting,setLogoutReporting} = reportingSlice.actions;

export default reportingSlice.reducer;
